import * as Yup from 'yup';

const validationSchema = Yup.object({
    convenience_fee_percentage: Yup.number('Fee must be a number')
        .positive('Fee must be a positive value')
        .required('Fee is required')
        .min(3, 'Fee must be greater than or equal to 3!')
        .max(100, 'Fee must be less than or equal to 100!')
});

export default validationSchema;